export const invoiceDbHd = [
  { label: 'Invoice Number', sortOption: false },
  { label: 'Type', sortOption: false },
  { label: 'Invoice Period', sortOption: false },
  { label: 'Invoice Date', sortOption: false },
  { label: 'Invoice Due Date', sortOption: false },
  { label: 'Amount', sortOption: false },
  { label: 'Status', sortOption: false }
]
